// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"n8-z"};